import {
    Component,
    DoCheck,
    ElementRef,
    Host,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    Renderer2,
    ViewEncapsulation
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputDirective } from '../../input.directive';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'input[euiInputText]',
    template: ``,
    styleUrls: ['./styles/_index.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EuiInputTextComponent extends InputDirective implements OnInit, OnDestroy, DoCheck {

    @HostBinding('class')
    public get cssClasses(): any {
        return [
            this.getCssClasses('eui-input-text'),
            this._isInvalid ? `eui-input-text--invalid` : '',
            this.styleClass ? this.styleClass : ``,
        ].join(' ').trim();
    }

    @Input() styleClass: string;

    @Input()
    public get isInvalid() {
        return this._isInvalid || null;
    }
    public set isInvalid(state: any) {
        this.setInvalid(state);
    }
    protected _isInvalid: boolean;

    constructor(
        @Optional() @Host() protected control: NgControl,
        protected _elementRef: ElementRef,
        protected _renderer: Renderer2) {
        super(_elementRef, _renderer, control);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngDoCheck() {
        if (this.control) {
            this.isInvalid = this.control.invalid && this.control.touched;
        }
    }

    protected setInvalid(state?: any): void {
        // in case it's controlled by NgControl override
        this._isInvalid = this.control ? this.control.invalid && this.control.touched : coerceBooleanProperty(state);

        // set BaseDirective Attribute
        super.euiDanger = this._isInvalid;
    }

}
